import { GetImg } from 'utils'
import styles from './styles.module.scss'
import { IMember } from 'models'
import { ReactComponent as Location } from 'assets/images/location.svg'

const MemberCard = ({ member, onClick, location = true, selected = false }: { member: IMember, onClick: any, location?: boolean, selected?: boolean }) => {
    return (
        <section className={selected ? styles.membeSelectedrCardContainer : styles.memberCardContainer}
            onClick={onClick}

        >
            <div className={styles.memberDetial}>
                <GetImg
                    className={styles.image}
                    endpoint={member.picture} />
                {/* <img
alt=""
style={{
    height:'120px',
    width:'120px',
    borderRadius:'50%',
    marginBottom:'15px'
}}
src="https://media.istockphoto.com/id/637696304/photo/patan.jpg?s=612x612&w=0&k=20&c=-53aSTGBGoOOqX5aoC3Hs1jhZ527v3Id_xOawHHVPpg=">
</img> */}
                <div className={styles.detials}>
                    <p className={styles.memberName}>
                        {member.full_name}
                    </p>
                    <p className={styles.communityName}>
                        {member.membership_type}
                    </p>
                    <span className={styles.loaction}>
                        <Location /> {member.distance}
                    </span>
                </div>
            </div>
        </section>
    )
}
export default MemberCard